import { render, staticRenderFns } from "./Yoshlar.vue?vue&type=template&id=1837394c&"
import script from "./Yoshlar.vue?vue&type=script&lang=js&"
export * from "./Yoshlar.vue?vue&type=script&lang=js&"
import style0 from "./Yoshlar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports